import MenuIcon from '@mui/icons-material/Menu';
import { Badge, Box, CircularProgress, Collapse, IconButton, List, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import logo from '../../../assets/images/logo-black.svg';
import styles from './navMobile.module.scss';
import { SET_USER_DATA, SOCKET_DISCONNNECT } from '../../../constants/actionTypes';
import cognitoService from '../../../core/service/cognito.service';
import colors from '../../../utils/colors';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser,
        isAdmin: state.user.currentUser.groups && state.user.currentUser.groups.includes('Admin')
    };
};

const mapDispatchToProps = (dispatch) => ({
    onLogout: () => {
        dispatch({
            type: SET_USER_DATA,
            payload: {
                data: null,
                token: null,
                loaded: true,
                imagePreview: null,
                name: null,
                nickname: null,
                step: false,
                surname: null,
                username: null
            }
        });
        dispatch({ type: SOCKET_DISCONNNECT });
    }
});

const NavMobile = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const path = window.location.pathname;
    const collapseRef = useRef();

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const deleteCookie = (name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    };

    const onLogout = () => {
        cognitoService.logoutUser();
        props.onLogout();
        deleteCookie('PremiumStatus');
        history.push('/');
    };

    const handleClickOutside = (event) => {
        if (collapseRef.current && !collapseRef.current.contains(event.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Box
            className={styles.flex}
            sx={{
                position: path.includes('home') ? 'relative' : 'sticky',
                zIndex: path.includes('home') && !open ? 1 : 999
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }} ref={collapseRef}>
                <Box>
                    <IconButton onClick={handleToggle} aria-label="menu">
                        <MenuIcon fontSize="large" />
                    </IconButton>
                    <Collapse in={open} timeout={0}>
                        <List
                            component="nav"
                            sx={{
                                bgcolor: 'background.paper',
                                width: '95%',
                                position: 'absolute',
                                zIndex: 999,
                                boxShadow: '0px 4px 15px 0px rgba(0, 0, 0, 0.25)',
                                borderRadius: '10px',
                                padding: '10px',
                                color: path === '/profile' ? 'black !important' : '',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                top: '100%'
                            }}>
                            {props?.user?.data && (
                                <>
                                    <Box
                                        sx={{
                                            fontSize: '20px',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.4px',
                                            fontFamily: 'InstrumentSans-semibold'
                                        }}
                                        onClick={() => history.push('/my-library')}>
                                        {t('MyLibrary')}
                                    </Box>
                                    {props.isAdmin && (
                                        <Box
                                            sx={{
                                                margin: props?.user?.data ? '1rem 0' : '0 0 1rem 0',
                                                fontSize: '20px',
                                                lineHeight: '100%',
                                                letterSpacing: '-0.4px',
                                                fontFamily: 'InstrumentSans-semibold'
                                            }}
                                            onClick={() => history.push('/profile')}>
                                            {t('Profile')}
                                        </Box>
                                    )}
                                </>
                            )}
                            {/* <Box
                                sx={{
                                    margin: props?.user?.data ? '1rem 0' : '0 0 1rem 0',
                                    fontSize: '20px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    fontFamily: 'InstrumentSans-semibold'
                                }}>
                                {t('About')}
                            </Box> */}
                            <Box
                                sx={{
                                    margin: props?.user?.data ? '0 0 1rem 0' : '0',
                                    fontSize: '20px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    fontFamily: 'InstrumentSans-semibold'
                                }}
                                onClick={() => history.push('/terms-and-conditions')}>
                                {t('TermsAndConditions')}
                            </Box>
                            {props?.user?.data && (
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        lineHeight: '100%',
                                        letterSpacing: '-0.4px',
                                        fontFamily: 'InstrumentSans-semibold'
                                    }}
                                    onClick={onLogout}>
                                    {t('SignOut')}
                                </Box>
                            )}
                        </List>
                    </Collapse>
                </Box>
                {props?.publishingVideos?.length > 0 && (
                    <span>
                        <Tooltip
                            title={
                                props?.publishingVideos?.length === 1
                                    ? `${props?.publishingVideos[0]?.title} is being published`
                                    : `${props?.publishingVideos?.length} videos are being published`
                            }
                            arrow>
                            <Badge
                                badgeContent={props?.publishingVideos?.length}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: colors.primary,
                                        color: 'black',
                                        minWidth: '15px',
                                        height: '15px',
                                        fontSize: '0.7rem',
                                        padding: '0'
                                    }
                                }}>
                                <CircularProgress
                                    sx={{
                                        width: '20px !important',
                                        height: '20px !important',
                                        color: colors.primary
                                    }}
                                />
                            </Badge>
                        </Tooltip>
                    </span>
                )}
            </Box>
            <img
                style={{ cursor: 'pointer', width: '35px', height: '35px' }}
                onClick={() => history.push(props.isAdmin ? '/home' : '/my-library')}
                src={logo}
                alt="logo"
            />
            {/* <Box onClick={() => history.push('/register')}>{t('SignUp')}</Box> */}
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(NavMobile);
